import React from "react";
import ReactMarkdown from "react-markdown";
import { useIsSmallScreen } from "../../App";
import { Padding } from "../../shared-components/Padding";
import { TEXT_COLOR, TEXT_INDENT, TEXT_SIZE } from "../../tokens";

export const Subheading: React.FC<{
    content: string;
}> = (props) => {
    const { content } = props;

    const isSmallScreen = useIsSmallScreen();

    return (
        <Padding onlySides>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                }}
                className="rubric"
                data-content={content}
            >
                <div
                    style={{
                        paddingLeft: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        paddingRight: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        color: TEXT_COLOR,
                        fontWeight: "bold",
                        fontSize: isSmallScreen ? TEXT_SIZE * 0.9 : TEXT_SIZE,
                        textAlign: "center",
                        flexGrow: 1,
                        paddingTop: 8,
                        paddingBottom: 8,
                    }}
                >
                    <ReactMarkdown>
                        {content
                            .replace(/\\n/g, "  \n")
                            .replace(/_/g, "\u00a0")}
                    </ReactMarkdown>
                </div>
            </div>
        </Padding>
    );
};
